import React, { useEffect } from 'react'
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { Link, useNavigate, useParams } from 'react-router-dom'
import { get, isEmpty } from "lodash";
import { MdNavigateNext } from 'react-icons/md'
import Swal from "sweetalert2";
import { Button, Container, Grid, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, InputLabel, Checkbox, FormControlLabel, Dialog, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { AiFillCloseCircle } from 'react-icons/ai';
import { useSelector, useDispatch } from 'react-redux'
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { setEditQuestion, stateValues, stateRefresh } from '../../slices/skillerSlice';
import axios from 'axios'
import moment from 'moment'
import Paper from '@mui/material/Paper';
import Skelton from '../../common/Skelton';
import { GET_MATCHED_COUNT, MAKE_GST_DATA, SKILLER_CANCEL, SKILLER_CHANGE_STATUS, SKILLER_DISTRIBUTE_WINNING, SKILLER_FORCE_CANCEL, SKILLER_LIST, SKILLER_WINNING_SET } from '../../constant/endpoint';
import { PREDICTION_TYPE_GST, useStyles } from '../../constant/constant';
import { getSweetAlert } from '../../helper';
import PredictionNvigation from '../../components/PredictionNvigation';
import {CircularProgress} from '@mui/material';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    height: '75%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    padding: '0px 30px',
    overflow: "auto",
    paddingBottom: "20px"
};

const Skiller = () => {
    const { match_id, series_id, sport } = useParams()
    const [open, setOpen] = React.useState(false);
    const [skiller, setSkiller] = React.useState([]);
    const [imageofQustion, setImageofQustion] = React.useState(undefined);
    const [value, setValue] = React.useState('1');
    const [sort, setSort] = React.useState({});
    const [Loading, setLoading] = React.useState(true);
    const [apiWork, setApiWork] = React.useState(false);
    const [circularLoader, setCircularLoader] = React.useState(false);
    const navigate = useNavigate();
    const classes = useStyles();
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const imageFile = (e) => {
        const file = e.target.files[0]
        setImageofQustion(file)
    }
    const handleOpen = () => {
        dispatch(stateRefresh())
        setOpen(true)
        setImageofQustion('')
        setApiWork(false)
        dispatch(stateValues({ name: 'predic_start_time', value: `${moment().format("YYYY-MM-DD")}T${moment().format("HH:mm")}` }))
    };
    const handleClose = () => setOpen(false);
    const dispatch = useDispatch();
    const skillerSlice = useSelector(state => state.skillerSlice)
    useEffect(() => {
        if (isEmpty(skiller) && Loading) {
            getSkillerList()
        }
    })

    const getSkillerList = async () => {
        setLoading(true)
        const response = await axios.get(SKILLER_LIST.replace(':match_id', match_id).replace(':series_id', series_id))
        if (response?.data?.status && !isEmpty(response.data.data)) {
            setSkiller(response.data.data)
        }
        setLoading(false)
    }

    const setQuestion = (e) => {

        if (e.target.name === "correct_answer") {

            let value = e.target.value
            if (/^[0-9]*$/.test(value) || value === '') {
                dispatch(stateValues({ name: e.target.name, value: value }))
            }

        }
        else {
            dispatch(stateValues({ name: e.target.name, value: e.target.value }))
        }
    }

    const selectCorrectAnswer = (e) => {
        const option = skillerSlice.questionStates.option.map(data => data.id === Number(e.target.value) ? { ...data, isCorrect: true } : { ...data, isCorrect: false })
        dispatch(stateValues({ name: 'option', value: option }))
    }
    const editOptions = (event, id) => {
        const option = skillerSlice.questionStates.option.map(data => data.id === Number(id) ? { ...data, option: event.target.value } : { ...data })
        dispatch(stateValues({ name: 'option', value: option }))
    }

    // Alert Function
    const getSweetAlert = (type, topic) => {
        Swal.fire({
            position: 'top-end',
            icon: type,
            title: topic,
            showConfirmButton: false,
            timer: 3000
        })
    }

    const submit = async () => {
        if (IsValidation()) {
            setApiWork(true)
            await submitQuestion()
        }
    }
    const updateScore = () => {
        dispatch(stateValues({ name: 'isEdit', value: true }))
        submitQuestion()
    }
    const submitQuestion = async () => {
        const formData = new FormData()
        let data = {
            ...skillerSlice.questionStates,
            match_id,
            series_id,
            sport: sport,
            predic_start_time: moment(skillerSlice.questionStates.predic_start_time).utc().format(),
            predic_end_time: moment(skillerSlice.questionStates.predic_end_time).utc().format(),
        }
        formData.append('image', imageofQustion);
        formData.append('data', JSON.stringify(data));
        delete data.status
        let result;
        if (skillerSlice.questionStates.isEdit) {
            result = await axios.patch(SKILLER_LIST.replace(':match_id', match_id).replace(':series_id', series_id), formData)
        } else {
            result = await axios.post(SKILLER_LIST.replace(':match_id', match_id).replace(':series_id', series_id), formData)

        }

        if (result?.data?.status === 'success') {
            setApiWork(false)
            if (!skillerSlice.isEdit) {
                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Question Successfully Added',
                    showConfirmButton: false,
                    timer: 1500
                })
            } else {
                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Question Successfully Edit',
                    showConfirmButton: false,
                    timer: 1500
                })
            }
        }
        getSkillerList()
        handleClose()
    }
    const IsValidation = () => {

        let status = true
        const data = skillerSlice.questionStates
        if (isEmpty(data.question_english)) {
            status = false
            getSweetAlert('error', 'Enter the question')
        } else if (data.slots_per_user <= 0) {
            status = false
            getSweetAlert('error', 'Enter Slot Per user')
        } else if (+data.slots_per_user > 10000) {
            status = false
            getSweetAlert('error', 'Slot not more than 10000')
        }
        else if (isEmpty(data.predic_start_time)) {
            status = false
            getSweetAlert('error', 'Start Time Must Be More Than Present Time')

        } else if (isEmpty(data.predic_end_time) || (moment(data.predic_end_time).format("YYYY-MM-DD, HH:mm") < moment(data.predic_start_time).format("YYYY-MM-DD, HH:mm"))) {
            status = false
            getSweetAlert('error', 'End Time Must be Larger Than Start Time')
        } else if (Number(data.admin_commission) < 10) {
            status = false
            getSweetAlert('error', 'Admin Commission Not Less Than 10')
        }
        else if (!data.start_range || data.start_range == 0 || data.start_range < 0) {
            status = false
            getSweetAlert('error', 'Enter the Start Range')
        }

        else if (!data.end_range || data.end_range == 0 || data.end_range < 0) {
            status = false
            getSweetAlert('error', 'Enter the End Range')
        }
        else if (Number(data.end_range) <= Number(data.start_range)) {
            status = false
            getSweetAlert('error', 'End Range should be more than Start Range')
        }
        else if (!data.score || data.score == 0 || Number(data.score) < 0 || Number(data.score) >= Number(data.end_range) || Number(data.score) <= Number(data.start_range)) {
            status = false
            getSweetAlert('error', 'Invalid Score!! It should be between Start and End Range')
        }
        else if (((Number(data.score) - Number(data.start_range)) % Number(data.interval)) !== 0) {
            status = false
            getSweetAlert('error', 'Score Should be correct format respective to interval')
        }
        else if (!data.interval || Number(data.interval) < 5) {
            status = false
            getSweetAlert('error', 'Interval should be atleast 5')
        }
        else if ((Number(data.end_range) - Number(data.start_range)) % Number(data.interval) !== 0) {
            status = false
            getSweetAlert('error', 'Invalid End Range or Interval')
        }
        return status
    }
    const editQuestion = (data) => {
        setImageofQustion('')
        setOpen(true)
        const inPlayData = {
            ...data,
            predic_start_time: `${moment(data.predic_start_time).format(
                "YYYY-MM-DD"
            )}T${moment(data.predic_start_time).format("HH:mm")}`,
            predic_end_time: `${moment(data.predic_end_time).format(
                "YYYY-MM-DD"
            )}T${moment(data.predic_end_time).format("HH:mm")}`,
            isEdit: true,
        };
        dispatch(setEditQuestion(inPlayData));
        getSkillerList()
    }
    const breadcrumbs = [
        <Link underline="hover" key="1" color="inherit" to={'/matchlist'} >
            <h4>Matchlist</h4>
        </Link>, <Link
            underline="hover"
            color="inherit"
        >
            Prediction
        </Link>, <h5>{'Skiller'}</h5>
    ];
    const questionStatus = async (status, _id) => {
        let data;
        if (status) {
            data = { status: 0, match_id, series_id, _id, sport: 1 }
        } else {
            data = { status: 1, match_id, series_id, _id, sport: 1 }
        }
        await axios.post(SKILLER_CHANGE_STATUS, data)
        getSkillerList()
    }
    const skillerCancel = async (data, _id) => {
        // const answer = data.option.filter(x => x.isCorrect)[0].option
        // let optionObj = {
        //     "Select answer": "Select answer"
        // };
        // for (var obj of data.option) {
        //     optionObj[obj.option] = obj.option
        // }
        const resultCheck = await Swal.fire({
            title: `Do you want to cancel ?`,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
        if (resultCheck.isConfirmed) {
            Swal.fire({
                title: 'Wait !',
                text: 'While We are cancelling',
                imageUrl: 'https://cdn.dribbble.com/users/164889/screenshots/1192618/loading-red-spot.gif',
                imageWidth: 400,
                imageHeight: 200,
                imageAlt: 'Custom image',
                showConfirmButton: false,
                allowOutsideClick: false
            })

            const result = await axios.post(
                SKILLER_CANCEL.replace(':match_id', match_id).replace(':series_id', series_id).replace(':skiller_id', data._id)
            );
            if (result?.data?.status === "success") {
                getSkillerList()
                Swal.close()
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Cancelled successfully",
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
        }


    }
    const validateScoreInput = async (data) => {
        Swal.fire({
            title: "Enter Answer",
            input: 'number',
            showCancelButton: true,
            confirmButtonColor: 'green'
        }).then(async (result) => {
            if (result.isConfirmed) {
                if (result.value == data.correct_answer) {
                    await setWinning(data)
                }
                else {
                    getSweetAlert('error', 'Incorrect Answer')
                }
            }
        });

    }
    const setWinning = async (data) => {
        const resultCheck = await Swal.fire({
            title: `Do you want Winning Set?`,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
        if (resultCheck.isConfirmed) {
            Swal.fire({
                title: 'Wait !',
                text: 'While We are setting the winning',
                imageUrl: 'https://cdn.dribbble.com/users/164889/screenshots/1192618/loading-red-spot.gif',
                imageWidth: 400,
                imageHeight: 200,
                imageAlt: 'Custom image',
                showConfirmButton: false,
                allowOutsideClick: false
            })
            // const optionAnser = data.option
            // const isCorrectId = (optionAnser.find(data => data.isCorrect)).id
            const bodyData = {
                // correct_id: isCorrectId,
                admin_commision: data.admin_commission
            }
            const result = await axios.post(
                SKILLER_WINNING_SET.replace(':match_id', match_id).replace(':series_id', series_id).replace(':id', data._id), bodyData
            );
            if (result?.data?.status === "success") {
                getSkillerList()
                Swal.close()
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Winning set successfully",
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
        }
    };
    const winningDistribution = async (id) => {
        const resultCheck = await Swal.fire({
            title: `Do you want Winning Distribute?`,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
        if (resultCheck.isConfirmed) {
            Swal.fire({
                title: 'Wait !',
                text: 'While We are distributing the winning',
                imageUrl: 'https://cdn.dribbble.com/users/164889/screenshots/1192618/loading-red-spot.gif',
                imageWidth: 400,
                imageHeight: 200,
                imageAlt: 'Custom image',
                showConfirmButton: false,
                allowOutsideClick: false
            })
            const result = await axios.post(
                SKILLER_DISTRIBUTE_WINNING.replace(':match_id', match_id).replace(':skiller_id', id)
            );
            if (result?.data?.status === 'success') {
                getSkillerList()
                Swal.close()
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Winning Distribution successfully",
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
        }
    };
    const forceCancelPrediction = async (skiller_id) => {
        const result = await Swal.fire({
            title: 'Do you want to cancel the prediction ?',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
        if (result.isConfirmed) {
            const result = await axios.post(
                SKILLER_FORCE_CANCEL.replace(':skiller_id', skiller_id)
            );
            if (result?.data?.status === 'success') {
                getSkillerList()
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Prediction Cancel successfully",
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
        }
    }

    const handleShorting = async (data) => {
        let data1 = {
            ...data
        }
        data1.sort_number = sort[data._id]?.sort_number ? sort[data._id]?.sort_number : data.sort_number
        delete data1.status
        const formData = new FormData()
        formData.append('image', imageofQustion);
        formData.append('data', JSON.stringify(data1));

        let result = await axios.patch(SKILLER_LIST.replace(':match_id', match_id).replace(':series_id', series_id), formData)

        if (result?.data?.status === 'success') {
            if (!skillerSlice.questionStates.isEdit) {
                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Sorting add Successfully',
                    showConfirmButton: false,
                    timer: 1500
                })
            } else {
                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Sort Add Successfully',
                    showConfirmButton: false,
                    timer: 1500
                })
            }
        }
        getSkillerList()
    }
    const handleSortingInput = (e, id) => {
        if (e.target.value) {
            setSort(prevValue => ({ ...prevValue, [id]: { sort_number: e.target.value } }))
        }
    }

    const RedirectFun = (match_id, series_id, name) => {
        navigate(`/matchlist/${name}/${match_id}/${series_id}`)
    }

    const getCount = async (id) => {
        const result = await axios.get(GET_MATCHED_COUNT.replace(':skiller_id', id))
        if(result?.data?.status === "success"){
            Swal.fire({
                position: 'center',
                icon: 'info',
                title: `${result?.data?.data}`,
                text: `Slots Matched`,
                showConfirmButton: false,
                timer: 1500
            })
        }
    }



    return (
        <>
            <div className="homeCard">
                <div className='subHomeCard'>
                <div >
                    <Breadcrumbs
                        separator={<MdNavigateNext fontSize="small" />}
                        aria-label="breadcrumb"
                    >
                        {breadcrumbs}
                    </Breadcrumbs>
                    {Banner(handleOpen, RedirectFun, match_id, series_id, sport,setCircularLoader)}
                        </div>
                    <Box sx={{ width: '100%', typography: 'body1' }}>
                        <TabContext value={value}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <TabList onChange={handleChange} aria-label="lab API tabs example">
                                    <Tab label="LIVE" value="1" />
                                    <Tab label="RESULT" value="2" />
                                </TabList>
                            </Box>
                            <TabPanel style={{ padding: "0px" }} value="1">
                                <TableContainer component={Paper} style={{ margin: "30px 0px" }}>
                                    <Table className={classes.table} width="100%" aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Id</TableCell>
                                                <TableCell align="left" >Question</TableCell>
                                                {/* <TableCell align="center">Score</TableCell> */}
                                                <TableCell align="center">End Time</TableCell>
                                                <TableCell align="center">Sorting</TableCell>
                                                <TableCell align="center">Answer</TableCell>
                                                <TableCell align="center">Count</TableCell>
                                                <TableCell align="center">Edit</TableCell>
                                                <TableCell align="center">Status</TableCell>
                                                <TableCell align="center">Cancel</TableCell>
                                                <TableCell align="center">Set</TableCell>
                                                <TableCell align="center">Force Cancel</TableCell>

                                            </TableRow>
                                        </TableHead>
                                        {circularLoader ?
                                            <div style={{ position: "absolute", left: "50%" }}>  <CircularProgress ></CircularProgress></div>
                                            :
                                            <TableBody>
                                                {skiller.filter((data) => !(data.is_finish) && !(data.is_processing)).length > 0 ? skiller.filter((data) => !(data.is_finish) && !(data.is_processing))?.map((data, index) => (
                                                    <TableRow
                                                        key={data.name}
                                                    >
                                                        <TableCell component="th" scope="row">
                                                            {index + 1}
                                                        </TableCell>
                                                        <TableCell style={{ width: 300 }}>{data.question_english}</TableCell>
                                                        {/* <TableCell align="center">{data.score}</TableCell> */}
                                                        <TableCell width={100} align="center">
                                                            {moment(data.predic_end_time).format("HH:mm")} <br></br>
                                                            {moment(data.predic_end_time).format("YYYY-MM-DD")}
                                                        </TableCell>

                                                        <TableCell align="left" style={{ display: "flex", background: '#ecffe2', width: "60px" }}>
                                                            <Grid container style={{ display: "flex", background: '#fff' }}>
                                                                <TextField type='number' width={'50px'} size='small' id="outlined-basic" label="Sorting" variant="outlined" style={{ fontStyle: "8px" }} onChange={(e) => handleSortingInput(e, data._id)} autocomplete="off" value={sort[data._id]?.sort_number ? sort[data._id]?.sort_number : data.sort_number} />
                                                                <Button variant='contained' color={'warning'} style={{ fontSize: "11px", width: "60px", padding: '1px' }} onClick={() => handleShorting(data)}>Update</Button>
                                                            </Grid>
                                                        </TableCell>
                                                        <TableCell align='center'>
                                                            <p>{data?.correct_answer}</p>
                                                        </TableCell>
                                                        <TableCell align='center'>
                                                            <Button variant={'contained'} size={'small'} color={'secondary'} onClick={() => getCount(data._id)}>Get Count</Button>
                                                        </TableCell>
                                                        <TableCell align='center'><Button variant={'contained'} size={'small'} color={'warning'} onClick={() => editQuestion(data)}>Edit</Button></TableCell>
                                                        <TableCell align='center'>
                                                            <Button variant={'contained'} size={'small'} color={data.status ? 'success' : 'error'} onClick={() => questionStatus(data.status, data._id)}  disabled={data?.correct_answer} >{data.status ? 'Active' : 'InActive'}</Button>
                                                        </TableCell>
                                                        <TableCell align='center'>
                                                            {
                                                                Number(data.status) === 0 && data?.correct_answer &&
                                                                <Button variant={'contained'} size={'small'} color={'error'} onClick={() => skillerCancel(data, data._id)} >Cancel</Button>
                                                            }
                                                        </TableCell>
                                                        <TableCell align='center'>
                                                            {
                                                                data.is_slot_cancel === 1 && data.is_pred_winset === 0 ? <Button variant={'contained'} size={'small'} color={'success'} onClick={() => validateScoreInput(data)}>Set</Button> : ''
                                                            }
                                                            {
                                                                data.is_pred_winset === 1 ? <Button style={{ margin: "5px 10px" }} variant={'contained'} size={'small'} color={'success'} onClick={() => winningDistribution(data._id)}>Distribute</Button> : ''
                                                            }
                                                        </TableCell>
                                                        <TableCell align='center'><Button variant={'contained'} size={'small'} color={'error'} onClick={() => forceCancelPrediction(data._id)} disabled={Number(data.status) === 1 ? true : false}>Force Cancel</Button></TableCell>
                                                    </TableRow>
                                                )) : Loading ? <Skelton /> : <TableRow><TableCell colSpan={12} style={{ textAlign: "center", padding: "10px" }}><h3>Data Not Found</h3></TableCell>
                                                </TableRow>}
                                            </TableBody>
                                        }
                                    </Table>
                                </TableContainer>
                            </TabPanel>
                            <TabPanel style={{ padding: "0px" }} value="2">
                                <TableContainer component={Paper} style={{ margin: "30px 0px" }}>
                                    <Table className={classes.table} sx={{ minWidth: 650 }} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Id</TableCell>
                                                <TableCell align="left">Question</TableCell>
                                                <TableCell align="center">End Time</TableCell>
                                                <TableCell align="center">Score</TableCell>
                                                <TableCell align="center">View</TableCell>
                                                <TableCell align="center">Cancel</TableCell>
                                                <TableCell align="center">Count</TableCell>
                                                <TableCell align="center">Set</TableCell>
                                                <TableCell align="center">Force Cancel</TableCell>
                                            </TableRow>
                                        </TableHead>                                   
                                            <TableBody>
                                                {skiller.filter((data) => data.is_finish).length > 0 ? skiller.filter((data) => data.is_finish)?.map((data, index) => (
                                                    <TableRow
                                                        key={data.name}
                                                    >
                                                        <TableCell component="th" scope="row">
                                                            {index + 1}
                                                        </TableCell>
                                                        <TableCell>{data.question_english}</TableCell>
                                                        <TableCell align="center">{moment(data.predic_end_time).format("HH:mm")} {moment(data.predic_end_time).format("YYYY-MM-DD")}</TableCell>
                                                        <TableCell align='center'>
                                                            {data.correct_answer}
                                                        </TableCell>
                                                        <TableCell align='center'><Button variant={'contained'} size={'small'} color={'warning'} onClick={() => editQuestion(data)} >View</Button></TableCell>
                                                        <TableCell align='center'>
                                                            <Button variant={'contained'} size={'small'} color={'error'} onClick={() => skillerCancel(data._id)} disabled >Cancel</Button>
                                                        </TableCell>
                                                        <TableCell align='center'>
                                                            <Button variant={'contained'} size={'small'} color={'secondary'} onClick={() => getCount(data._id)}>Get Count</Button>
                                                        </TableCell>
                                                        <TableCell align='center'>
                                                            {
                                                                data.is_slot_cancel === 1 ? <Button variant={'contained'} size={'small'} color={'success'} onClick={() => setWinning(data)} disabled>Set</Button> : ''
                                                            }
                                                            {
                                                                data.is_pred_winset === 1 ? <Button style={{ margin: "5px 10px" }} variant={'contained'} size={'small'} color={'success'} onClick={() => winningDistribution(data._id)} disabled>Distribute</Button> : ''
                                                            }
                                                        </TableCell>
                                                        <TableCell align='center'><Button variant={'contained'} size={'small'} color={'error'} onClick={() => forceCancelPrediction(data._id)} disabled={data.distribute_winning}>Force Cancel</Button></TableCell>
                                                    </TableRow>
                                                )) : Loading ? <Skelton /> : <TableRow><TableCell colSpan={12} style={{ textAlign: "center", padding: "10px" }}><h3>Data Not Found</h3></TableCell></TableRow>}
                                            </TableBody>
                                    </Table>
                                </TableContainer>
                            </TabPanel>
                        </TabContext>
                    </Box>
                </div>

            </div>
            {EditModal(open, setOpen, handleClose, skillerSlice, setQuestion, editOptions, submit, selectCorrectAnswer, imageFile, apiWork)}

        </>
    )
}

const Banner = (handleOpen, RedirectFun, match_id, series_id , sport, setCircularLoader) => {
    
    const makeGSTData = async (match_id, series_id) => {
        const isValid = await Swal.fire({
            title: 'Do you want to Close the Match ?',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
        if (isValid.isConfirmed) {
            setCircularLoader(true)
            const res = await axios.post(MAKE_GST_DATA.replace(':match_id', match_id).replace(':series_id', series_id).replace(':type', PREDICTION_TYPE_GST.SKILLER))
            if (res.data.status === "success") {
                getSweetAlert('Success', "Match Closed Successfully")
            }
            setCircularLoader(false)
        }
    }

    return (<div>
        <Container maxWidth="xl">
            <Grid container style={{ display: "flex", justifyContent: "space-between", paddingBottom: "20px", borderBottom: "1px solid #ccc" }}>
                <Grid item spacing={3}>
                    <Stack className="subHomeCardHeader" spacing={{ xs: 1, sm: 2 }} direction="row" useFlexGap flexWrap="wrap" mt={2}>
                        <Button variant={'contained'} color="primary" onClick={() => handleOpen()}>Add Questions</Button>
                    </Stack>
                </Grid>
                <Grid item>
                    <Grid container style={{ display: "flex", justifyContent: "flex-end", paddingBottom: "20px", }}>
                        <Grid item spacing={3}>
                            <Stack spacing={{ xs: 1, sm: 2 }} direction="row" useFlexGap flexWrap="wrap" mt={2}>
                                <Button variant={'contained'} color='warning' style={{ color: "black", marginRight: "10px" }} onClick={() => makeGSTData(match_id, series_id)}>Match Closed</Button>
                            </Stack>
                        </Grid>
                        <PredictionNvigation match_id={match_id}  series_id={series_id} sport={sport} />
                    </Grid>
                </Grid>
            </Grid>
        </Container>
    </div>)
}

const EditModal = (open, setOpen, handleClose, skillerSlice, setQuestion, editOptions, submit, selectCorrectAnswer, imageFile, apiWork) => {
    const dispatch = useDispatch();
    return (<Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        onBackdropClick={() => setOpen(true)}
    >
        <Box sx={style} spacing={0.5} direction="row" useFlexGap flexWrap="wrap">
            <Grid container>
                <Grid xs={11}>
                    <h2 id="modal-title" mb={1}>Skiller Questions</h2>
                </Grid>
                <Grid xs={1}>
                    <Button onClick={handleClose}><AiFillCloseCircle style={{ width: "25px", height: "40px" }} /></Button>
                </Grid>
                <h4> {skillerSlice.questionStates._id && 'Pred id-'}  {skillerSlice?.questionStates?._id}</h4>
            </Grid>
            <hr />
            <Grid container spacing={1}>
                <Grid xs={4} item>
                    <label>Slots Per User</label>
                    <TextField id="outlined-basic" type='number' size={'small'} variant="outlined" name={'slots_per_user'} onChange={setQuestion} value={skillerSlice.questionStates.slots_per_user} disabled={skillerSlice.isEdit === true ? true : false} />
                </Grid>
                <Grid xs={6} item>
                    <label>Admin Per Commission</label>
                    <TextField id="outlined-basic" type='number' size={'small'} variant="outlined" name={'admin_commission'} onChange={setQuestion} value={skillerSlice.questionStates.admin_commission} disabled={skillerSlice.isEdit === true ? true : false} />
                </Grid>
                <Grid container ml={1} mt={1}>
                    <Grid xs={6} item>
                        <label>Start Date and Time</label>
                        <TextField type='datetime-local' id="outlined-basic" size={'small'} variant="outlined" name={'predic_start_time'} value={skillerSlice.questionStates.predic_start_time} onChange={setQuestion} disabled={skillerSlice.isEdit === true ? true : false} />
                    </Grid>
                    <Grid xs={6} item>
                        <label>End Date and Time</label>
                        <TextField type='datetime-local' id="outlined-basic" size={'small'} variant="outlined" name={'predic_end_time'} value={skillerSlice.questionStates.predic_end_time} onChange={setQuestion} disabled={get(skillerSlice, "questionStates.is_finish")} />
                    </Grid>
                </Grid>
                <Grid xs={6} item mt={1}>
                    <label>Start Range</label>
                    <br></br>
                    <TextField id="outlined-basic" type='number' size={'small'} variant="outlined" name={'start_range'} value={skillerSlice.questionStates.start_range} onChange={setQuestion} disabled={get(skillerSlice, "questionStates.is_finish")}></TextField>

                </Grid>
                <Grid xs={6} item mt={1}>
                    <label>End Range</label>
                    <br></br>
                    <TextField id="outlined-basic" type='number' size={'small'} variant="outlined" name={'end_range'} value={skillerSlice.questionStates.end_range} onChange={setQuestion} disabled={get(skillerSlice, "questionStates.is_finish")}></TextField>

                </Grid>
                <Grid xs={6} item mt={1}>
                    <label>Starting Score</label>
                    <br></br>
                    <TextField id="outlined-basic" type='number' size={'small'} variant="outlined" name={'score'} value={skillerSlice.questionStates.score} onChange={setQuestion} disabled={get(skillerSlice, "questionStates.is_finish")}></TextField>

                </Grid>
                <Grid xs={6} item mt={1}>
                    <label>Interval</label>
                    <br></br>
                    <TextField id="outlined-basic" type='number' size={'small'} variant="outlined" name={'interval'} value={skillerSlice.questionStates.interval} onChange={setQuestion} disabled={get(skillerSlice, "questionStates.is_finish")}></TextField>

                </Grid>
                <Grid xs={6} item mt={1}>
                    <label>Entry Fee</label>
                    <br></br>
                    <TextField id="outlined-basic" type='number' size={'small'} variant="outlined" name={'entry_fee'} value={skillerSlice.questionStates.entry_fee} onChange={setQuestion} disabled={skillerSlice.isEdit === true ? true : false}></TextField>

                </Grid>


                <FormControlLabel control={<Checkbox onChange={(e) => dispatch(stateValues({ name: 'is_global_skiller', value: !skillerSlice?.questionStates?.is_global_skiller }))} name={'is_global_skiller'} defaultChecked={skillerSlice?.questionStates?.is_global_skiller} value={skillerSlice?.questionStates?.is_global_skiller} />} label="Global Skiller" />

                {/* <Grid xs={12} item mt={1}>
                    <label>Score</label>
                    <br></br>
                <TextField id="outlined-basic" type='number' size={'small'} variant="outlined" name={'score'} value={skillerSlice.questionStates.score} onChange={setQuestion}></TextField>
                </Grid> */}


                <Grid xs={12} item mt={1}>
                    <label>Write Question in English</label>
                    <TextField fullWidth id="standard-basic" size={'small'} placeholder="Write Question in English" name={'question_english'} value={skillerSlice.questionStates.question_english} variant="outlined" onChange={setQuestion} disabled={get(skillerSlice, "questionStates.is_finish") || get(skillerSlice, "questionStates.status") === 1} />
                </Grid>
                <Grid xs={12} item mt={1}>
                    <label>Write Question in Hindi</label>
                    <TextField fullWidth id="standard-basic" size={'small'} placeholder="Write Question in Hindi" name={'question_hindi'} value={skillerSlice.questionStates.question_hindi} variant="outlined" onChange={setQuestion} disabled={get(skillerSlice, "questionStates.is_finish") || get(skillerSlice, "questionStates.status") === 1} />
                </Grid>


                {skillerSlice.questionStates.isEdit &&
                    <Grid xs={12} item mt={1} mb={2}>
                        <label>Score Input</label>
                        <br></br>
                        <TextField id="outlined-basic" type="text" size={'small'} variant="outlined" name={'correct_answer'} value={skillerSlice.questionStates.correct_answer} onChange={(event) => setQuestion(event)}
                            disabled={get(skillerSlice, "questionStates.status")
                                ||
                                skillerSlice.questionStates.is_pred_winset ? true : false}

                        ></TextField>

                    </Grid>
                }

                {/* {
                    <Grid xs={12} mt={1} item>
                        <label>Options</label>
                        {skillerSlice?.questionStates?.option?.length ? skillerSlice?.questionStates?.option.map((data) => (
                            <TextField style={{ marginBottom: '10px' }} fullWidth value={data?.option} size={'small'} disabled={true} onChange={(event) => editOptions(event, data.id)}></TextField>
                        )) : ""}
                    </Grid>
                } */}
                {

                    <>
                        {/* {skillerSlice.questionStates.isEdit &&
                            <Grid item container>
                                <FormControl variant="outlined" size={'small'} sx={{ m: 1, minWidth: '100%' }}>
                                    {!isEmpty(skillerSlice.questionStates.option) &&
                                        <>
                                            <InputLabel id="demo-simple-select-label">Please Select Answer</InputLabel>
                                        <Select id="demo-simple-select-label" style={{ margin: '10px' }} type='select'
                                            value={get(get(skillerSlice, 'questionStates.option', []).find(data => data.isCorrect), 'id', '')}
                                            disabled={get(skillerSlice, "questionStates.status")
                                                || skillerSlice.questionStates.is_slot_cancel === 1 ||
                                                skillerSlice.questionStates.is_finish ? true : false}
                                            onChange={selectCorrectAnswer}>
                                                {get(skillerSlice, 'questionStates.option', []).map((data, index) =>
                                                    <MenuItem value={data.id} key={index}>{data?.option}</MenuItem>
                                                )}
                                            </Select>
                                        </>
                                    }
                                </FormControl>
                            </Grid>
                        } */}
                        <Grid xs={12} mt={1}>
                            <input
                                accept="image/*"
                                id="contained-button-file"
                                multiple
                                type="file"
                                onChange={imageFile}
                            />
                        </Grid>
                        <Grid xs={9} mt={2}>
                            <Button color='error' onClick={handleClose} variant="contained">Cancel</Button>
                        </Grid>
                        <Grid xs={3} mt={2} textAlign={'right'}>
                            <Button onClick={submit} variant="contained" disabled={apiWork}>Submit</Button>
                        </Grid>
                    </>
                }
            </Grid>
        </Box>
    </Modal>)
}

export default Skiller